import React, { forwardRef } from 'react'

/**
 * Wspólna oprawa własnych ikon w stylu Heroicons „outline”: siatka 24x24, kreska 1,5 w kolorze
 * tekstu, zaokrąglone końce i łączenia. Dzięki temu stoją obok ikon z `@heroicons/react` bez
 * różnicy grubości, a rozmiar i kolor ustawia się tak samo, klasami `w-* h-* text-*`.
 *
 * Domyślnie `aria-hidden`, jak w Heroicons: ikona stoi obok podpisu, który niesie nazwę.
 */
const ObrysIkony = forwardRef(({ children, ...props }, ref) => (
  <svg
    ref={ref}
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-slot='icon'
    {...props}
  >
    {children}
  </svg>
))

export default ObrysIkony
